import { render, staticRenderFns } from "./backoffice-agendamento.vue?vue&type=template&id=32a9b490&scoped=true"
import script from "./backoffice-agendamento.vue?vue&type=script&lang=ts"
export * from "./backoffice-agendamento.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-agendamento.vue?vue&type=style&index=0&id=32a9b490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a9b490",
  null
  
)

export default component.exports